import React, { useState } from "react";
import classNames from "classnames";
import "./index.scss";

import Dropdown from "../Dropdown";

const ConfirmCombo = ({
  values,
  comboKey,
  comboValueField,
  onApply,
  onCancel
}) => {
  const [comboVal, setComboVal] = useState({});
  const onSelect = value => {
    setComboVal(value);
  };

  return (
    <>
      <div className={classNames("comboWrapper")}>
        <Dropdown
          values={values}
          labelField={comboValueField}
          valueField={comboKey}
          searchBy={comboValueField}
          value={comboVal[comboValueField] || ""}
          onSelect={val => onSelect(val)}
        />
      </div>
      <div className={classNames("confirmComboControls")}>
        <div className={classNames("cancel")} onClick={onCancel} />
        <div
          className={classNames("apply")}
          onClick={() => onApply(comboVal[comboKey])}
        />
      </div>
    </>
  );
};

export default ConfirmCombo;
